import './index.css';
import { Route, Routes, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import useAuth from './hooks/useAuth';
import CustomerSidebar from './components/customer/sidebar/SideBar';
import MerchantSidebar from './components/merchant/sidebar/SideBar';
import EmployeeSidebar from './components/employee/sidebar/SideBar';
import ManagerSidebar from './components/manager/sidebar/SideBar';
import AdminSidebar from './components/admin/sidebar/SideBar';
import Navbar from './components/common/navbar/Navbar';
import Home from './pages/common/home/Home';
import About from './pages/common/about/About';
import Contact from './pages/common/contact/Contact';
import SignUp from './pages/common/sign-up/SignUp';
import Login from './pages/common/login/Login';
import ForgotPassword from './pages/common/forgot-password/ForgotPassword';
import ResetPassword from './pages/common/reset-password/ResetPassword';
import NotFound from './components/common/not-found/NotFound';
import Loading from './components/common/loading/Loading';
import Toast from "./components/common/toast/Toast";

const App = () => {

  const { token, user, isAppRendered } = useAuth();

  const renderSidebar = () => {
    switch (user["role"]) {
      case 'customer':
        return <CustomerSidebar />;
      case 'merchant':
        return <MerchantSidebar />;
      case 'employee':
        return <EmployeeSidebar />;
      case 'manager':
        return <ManagerSidebar />;
      case 'admin':
        return <AdminSidebar />;
      default:
        return <NotFound />;
    }
  };

  return (
    <>
      <Toast />
      <Navbar />
      {isAppRendered ? (
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/home" element={<Home />} />
          <Route exact path="/contact" element={<Contact />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/forgot-password" element={<ForgotPassword />} />
          <Route exact path="/forgot-password/:token" element={<ResetPassword />} />
          <Route exact path="/logout" element={<NotFound isLogout={true} />} />
          {token ? (
            <>
              <Route exact path="/banking" element={renderSidebar()} />
              <Route exact path="/login" element={<Navigate replace to="/logout" />} />
              <Route exact path="/sign-up" element={<Navigate replace to="/logout" />} />
              <Route exact path="/internal-sign-up" element={<Navigate replace to="/logout" />} />
            </>
          ) : (
            <>
              <Route exact path="/internal-sign-up" element={<SignUp />} />
              <Route exact path="/sign-up" element={<SignUp />} />
              <Route exact path="/login" element={<Login />} />
            </>
          )}
          <Route path="*" element={<NotFound />} />
        </Routes>
      ) :
        <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}><Loading /></Box>
      }
    </>
  );
}

export default App;
